import $ from 'jquery'


const object = vnObject

const searchInput = $('.js-search-input');
const taxSelect = $('.js-select-tax');
var typingTimer;
var doneTypingInterval = 1500;
const postsSection = $('.js-search-result');
const paginateSection = $('.js-search-pagination');

searchInput.on('input', function() {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(ajaxSearch, doneTypingInterval);
});

taxSelect.on( 'change', function() {
    ajaxSearch()
});


function ajaxSearch() {
    var searchVal = searchInput.val();
    var categoryId = taxSelect.val();
    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
            nonce: object.nonce,
            action: 'vn_post_search',
            post: searchInput.attr('data-post-type'),
            taxo: taxSelect.attr('data-tax'),
            term: categoryId,
            keyword: searchVal,
        },
        success: function (res) {
            if ( res.length !== 0 ) {
                postsSection.html('')
                paginateSection.html('')
                paginateSection.html( res.data.paginate )
                res.data.data.forEach((item, index) => {
                    postsSection.append(item)
                })
            }
        },
    });
}
